import { createFeatureManager } from '@justeat/feature-management'
import settings from './featureManager.settings'

// https://pages.github.je-labs.com/experimentation-platform/portal-documentation/docs/sdks/javascript/usage
// Use: import fm from featureManger -> await fm.loadFromCdn() -> fm.getValue(<YOUR-FEAT-NAME>)


/**
 * Set settings.onTrack callback for experiments
 * Create Feat Manager instance
 * Load Features from CDN
 * Fetch Feature values
 * @param {Object} features made of `{ name<String>, Type<String>, value<Str|Int|Bool>, experiment<Object> }`
 *  - Note: See examples of features in `./featureManager.features`
 * @returns the features Object with updated values from feature and experiments
 */
// eslint-disable-next-line no-unused-vars
export default async function getFeatures(features = {}) {
  const featKeys = Object.keys(features)
  if (featKeys.length === 0) return undefined

  // FM settings: Call back with experiments linked to requested features
  settings.onTrack = async(key, variant) => {
    featKeys.map(k => {
      if (features[k].experiment?.key && features[k].experiment.key === key) {
        features[k].experiment.variant = variant
        return features[k]
      }
      return undefined
    })
  }

  const fm = createFeatureManager(settings)
  await fm.loadFromCdn()

  // Request values
  featKeys.forEach(key => {
    switch (features[key].type) {
      case 'boolean':
        features[key].value = fm.getBooleanValue(features[key].name)
        break
      case 'integer':
        features[key].value = fm.getIntegerValue(features[key].name)
        break
      case 'string':
        features[key].value = fm.getStringValue(features[key].name)
        break
      default:
        features[key].value = fm.getValue(features[key].name)
    }
    return features[key]
  })

  return features
}
